// src/components/CustomDrawer.js
import React from "react";
import { Drawer, Card } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const CustomDrawer = ({
  title,
  visible,
  onClose,
  footer,
  width = "45%",
  children,
  zIndex = 1002,

}) => {
  return (
    <Drawer
      title={title}
      width={width}
      zIndex={zIndex}
      onClose={onClose}
      visible={visible}
    bodyStyle={{ paddingBottom: 20 }}

      headerStyle={{
        padding: '10px 16px',
        background: '#f0f2f5',
        borderBottom: '1px solid #e8e8e8',
      }}
      footerStyle={{
        backgroundColor: "#f0f2f5",
        borderTop: "1px solid #e8e8e8",
      }}
      footer={footer}
   
    >
      <Card
        style={{
          margin: "0px",
          padding: "0px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        {children}
      </Card>
    </Drawer>
  );
};

export default CustomDrawer;
